import { getAllMessages } from '../storage/chatStore.ts'

let cachedLast = 0

/** ID monotono compatibile Android (epoch ms, crescente). */
export async function nextMessageId(): Promise<string> {
  const all = await getAllMessages()
  let max = cachedLast
  for (const m of all) {
    const n = Number.parseInt(m.id, 10)
    if (!Number.isNaN(n) && n > max) max = n
  }
  const now = Date.now()
  const id = Math.max(now, max + 1)
  cachedLast = id
  return String(id)
}

export function normalizeMessageId(raw: unknown, fallback = Date.now()): string {
  if (typeof raw === 'number' && Number.isFinite(raw)) return String(Math.trunc(raw))
  if (typeof raw === 'string' && raw.trim()) {
    const n = Number.parseInt(raw.trim(), 10)
    if (!Number.isNaN(n)) return String(n)
    return raw.trim()
  }
  return String(fallback)
}
